import { nanoid } from 'nanoid';

/**
 * Idempotency keys for a write the user may retry. Sending a request again unchanged,
 * as a retry after a lost response does, reuses its key so the server answers with the
 * first attempt's result; any other request gets a new key and is written for real.
 */
export const idempotencyKeys = () => {
  const keys = new Map<string, string>();
  return {
    keyFor: (request: unknown): string => {
      const signature = JSON.stringify(request);
      let key = keys.get(signature);
      if (!key) {
        key = nanoid();
        keys.set(signature, key);
      }
      return key;
    },
    /** Forgets every key, once their requests are known to have landed. */
    reset: () => keys.clear()
  };
};
